import i18n from 'i18next'

/**
 * Тексти ядра, які в Астеріксі звучать інакше (`SPEC-014` Q14.7, варіант (а)):
 * дослівно з легасі, без змін у сабмодулі `Core`.
 *
 * Ключ — той самий, що в `Core/Locales/uk/translation.json`; вартовий у
 * `CoreTextOverrides.test.ts` перевіряє, що кожен ключ там справді є, — інакше
 * перевизначення мовчки нічого не робило б.
 *
 * «Відновити пароль» замість ядрового «Скинути пароль» уже стоїть у власній
 * формі відновлення (`AuthContainer/ForgotPasswordForm`), тож тут лише те, що
 * показують ядрові компоненти.
 */
export const CORE_TEXT_OVERRIDES: Record<string, string> = {
    // Ядровий `LoginForm` на невідомій помилці входу (Core uk `:9-10` легасі)
    'An unknown error has occurred. Please contact the administrator.':
        'Сталася невідома помилка. Зверніться, будь ласка, до адміністратора.',
}

/**
 * Накласти перевизначення на простір `Core` поточної мови.
 *
 * Простір за замовчуванням (`Ship`) не змінюється: `addResourceBundle` з
 * `deep` і `overwrite` дописує лише перелічені ключі.
 */
export const applyCoreTextOverrides = (): void => {
    const language = i18n.language || 'uk'

    i18n.addResourceBundle(language, 'Core', CORE_TEXT_OVERRIDES, true, true)
}
